import uniqBy from 'lodash/uniqBy';

import { GENERAL_MANAGEMENT_AGREEMENT_TYPE } from 'constants/index';

import { condenseImageObject, expandImageObject } from 'utils/globals/imageOptimizatons';

import { ENTITY_TYPES } from 'operabase-router/constants';

export const transformAgencyDataForDisplay = ({ data, entityType }) => {
  if (!data) {
    return [];
  }

  const transformedData = data.map(item => {

    const agency = item.agencyOrganization;
    
    const transformedItem = {
      ...item,
      agency: {
        ...agency,
        contacts: agency?.contacts || [], // Ensure contacts array exists even if empty
      },
    };

    const agencyConnectionProfessions =
      entityType === ENTITY_TYPES.ORGANIZATION
        ? [
            {
              contactPersons: uniqBy(item?.agreements?.map(agreement => agreement?.contactPersons || []).flat(), 'id'),
              agreements: item?.agreements,
            },
          ]
        : item?.agencyConnectionProfessions;

    const contactPerson = agencyConnectionProfessions?.reduce((acc, acp) => {
      if (!acc) {
        const contact = acp?.contactPersons?.[0];

        if (contact) {
          return contact;
        }
      }

      return acc;
    }, null);

    // Extract all agents/contact persons from all agreements
    const allAgents = agencyConnectionProfessions?.flatMap(connection =>
      connection?.agreements?.flatMap(agreement =>
        agreement?.contactPersons?.map(cp => ({
          id: cp?.id,
          name: cp?.employee?.name || `${cp?.employee?.firstName || ''} ${cp?.employee?.lastName || ''}`.trim(),
          firstName: cp?.employee?.firstName,
          lastName: cp?.employee?.lastName,
          email: cp?.employee?.workEmail?.email || cp?.employee?.accessEmail,
          agreementType: agreement?.agreementType,
          agreementId: agreement?.id,
          startDate: cp?.startDate,
          endDate: cp?.endDate,
          isActive: !cp?.endDate || new Date(cp?.endDate) > new Date(),
        })) || []
      ) || []
    ) || [];

    // Remove duplicates based on agent ID and keep unique agents
    const uniqueAgents = uniqBy(allAgents.filter(agent => agent?.name), 'id');

    const isGM = agencyConnectionProfessions.some(connection =>
      connection.agreements?.some(agreement => agreement?.agreementType === GENERAL_MANAGEMENT_AGREEMENT_TYPE),
    );

    return { ...transformedItem, isGM, contactPerson, agencyConnectionProfessions, agents: uniqueAgents };
  });

  return transformedData.sort((a, b) => b.isGM - a.isGM);
};

export const transformFeaturedHomepageAgencies = response => {
  const { data } = response || {};

  return {
    ...response,
    data: data?.map(option => ({
      entity: {
        id: option?.id,
        name: option?.name,
        slug: option?.slug,
        source_tag: option?.source_tag,
        city: { name: option?.city?.name },
        country: { name: option?.country?.name },
        logo: condenseImageObject(option?.logo),
        organizationType: option?.organizationType || { id: 70, name: 'Agency' }, // Use API data or fallback
      },
      entityType: ENTITY_TYPES.ORGANIZATION,
    })),
  };
};

export const selectFeaturedHomepageAgencies = response => {
  const { data } = response || {};

  return data?.map(option => ({
    ...option,
    entity: {
      ...option?.entity,
      logo: expandImageObject(option?.entity?.logo),
      ...(option?.city && { city: { name: option?.city } }),
      ...(option?.country && { country: { name: option?.country } }),
    },
  }));
};
